import { graphql } from "~/gql";

export const NOTIFICATION_RULE_QUERY = graphql(/* GraphQL */ `
  query NotificationRules($data: notificationRuleQueryInput!) {
    notificationRules(data: $data) {
      ...NotificationRuleParts
    }
  }
`);
